import 'angular:locale/data:lt';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "lt";
